import React from 'react';
import { Box, Card, CardContent, Container, Grid, Typography } from '@mui/material';
import { getImageUrl } from '../services/api';
import Seo from '../components/Seo';

const hotelImageUrl = getImageUrl('AboutUs.jpg', 'logos');

const RulesAndRegulation = () => (
  <Box sx={{ backgroundColor: '#f8fafc', minHeight: '100vh', pt: { xs: 12, md: 14 }, pb: 8 }}>
    <Seo
      title="Rules & Regulation"
      description="Helpful information for your stay at Grosvenor Plymouth, including check-in times, check-out times, breakfast service, and guest guidance."
      keywords="Rules and Regulation, Grosvenor Plymouth, check in time, check out time, breakfast time"
      author="Grosvenor Plymouth"
    />

    <Container maxWidth="lg">
      <Box sx={{ textAlign: 'center', mb: 5 }}>
        <Typography
          variant="h2"
          sx={{
            fontFamily: 'Playfair Display',
            fontWeight: 700,
            color: 'primary.main',
            mb: 2,
            fontSize: { xs: '2.2rem', md: '3rem' }
          }}
        >
          Rules & Regulation
        </Typography>
        <Typography
          variant="body1"
          sx={{
            maxWidth: 760,
            mx: 'auto',
            color: '#4b5563',
            lineHeight: 1.85,
            fontSize: { xs: '1rem', md: '1.05rem' }
          }}
        >
          Helpful information for your stay at Grosvenor Plymouth, including check-in times, check-out times, breakfast service, and guest guidance.
        </Typography>
      </Box>

      <Card
        sx={{
          borderRadius: 5,
          overflow: 'hidden',
          boxShadow: '0 18px 45px rgba(15, 23, 42, 0.08)'
        }}
      >
        <Box
          component="img"
          src={hotelImageUrl}
          alt="Grosvenor Plymouth"
          sx={{
            width: '100%',
            height: { xs: 260, md: 380 },
            objectFit: 'cover',
            display: 'block'
          }}
        />

        <CardContent sx={{ p: { xs: 3, md: 5 } }}>
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Typography
                variant="h4"
                sx={{
                  fontFamily: 'Playfair Display',
                  fontWeight: 700,
                  color: 'primary.main',
                  mb: 2,
                  fontSize: { xs: '1.6rem', md: '2rem' }
                }}
              >
                Check In / Check Out Times
              </Typography>
              <Typography variant="body1" sx={{ color: '#4b5563', lineHeight: 2, whiteSpace: 'pre-line' }}>
                {'Check In: 2pm to 10 pm\n\nCheck Out: 7.30 am to 11 am\n\n*Early Check In: Mid day\n\n**Late Check Out: 1pm\n\n* both subject to availability, each at an additional cost of £10.00 per room.'}
              </Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography
                variant="h4"
                sx={{
                  fontFamily: 'Playfair Display',
                  fontWeight: 700,
                  color: 'primary.main',
                  mb: 2,
                  fontSize: { xs: '1.6rem', md: '2rem' }
                }}
              >
                Breakfast Times
              </Typography>
              <Typography variant="body1" sx={{ color: '#4b5563', lineHeight: 2, whiteSpace: 'pre-line' }}>
                {'Monday to Friday: 7am to 9:30am\n\nWeekend & Bank Holidays: 7:30am to 10am\n\nBar is temporarily closed.'}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Container>
  </Box>
);

export default RulesAndRegulation;
